import Button from '@mui/material/Button';
import ChevronRight from '@mui/icons-material/ChevronRight';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ReactElement, useState } from 'react';

import { IArchivedMedicaidPlan } from '~/services/api/medicaidPlan/types';
import Loader from '~/ui/components/common/Loader';

import formatActivePeriod from './helpers/formatActivePeriod';
import sortNewestFirst from './helpers/sortNewestFirst';

import styles from './MedicaidHistory.module.scss';

interface IMedicaidHistoryProps {
  history: IArchivedMedicaidPlan[];
  isLoading: boolean;
  onOpen: (plan: IArchivedMedicaidPlan) => void;
}

const MedicaidHistory = ({
  history,
  isLoading,
  onOpen,
}: IMedicaidHistoryProps): ReactElement | null => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (isLoading && !history.length) return <Loader />;
  if (!history.length) return null;

  return (
    <div className={styles.history}>
      <Button
        color="primary"
        size="small"
        aria-expanded={isExpanded}
        endIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
        onClick={() => setIsExpanded(value => !value)}
        className={styles.toggle}
      >
        Medicaid History
      </Button>
      {isExpanded && (
        <ul className={styles.list}>
          {sortNewestFirst(history).map(plan => (
            <li key={plan.id}>
              <button type="button" className={styles.row} onClick={() => onOpen(plan)}>
                <span className={styles.type}>{plan.medicaidType?.name}</span>
                <span className={styles.period}>{formatActivePeriod(plan)}</span>
                <ChevronRight aria-hidden className={styles.chevron} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MedicaidHistory;
